/**
 * 描述：自定义文本溢出处理
 * 作者：Bai.Zhiming
 * 日期：2017-10-8
 */
"use strict";
angular.module("textOverflowModule", []).
directive("textOverflow", ["$timeout", function($timeout) {
    return {
        replace: false,
        restrict: 'A',
        scope: false,
        transclude: false,
        link: function(scope, $elem, $attrs) {
            $timeout(function() {
                var wordArray = $elem.html().split("-");
                if (wordArray.length > 3) {
                    $elem.html(wordArray[0] +"-"+wordArray[1]+ "-...-" + wordArray[wordArray.length - 1]);
                }
            }, 500);
        }
    };
}]);